import constants from 'constants/index'

const statusName = (status) => {
  switch (status) {
    case constants.companyService.ACTIVE_STATUS:
      return 'ATIVO'
    case constants.companyService.INACTIVE_STATUS:
      return 'INATIVO'
    default:
      return '-'
  }
}

export default statusName
